import { AddressDTO } from "./addressDTO";

export class BrokerInfoDTO{

    public brokerId!:number;
    public brokerageName!:string;
    public agentFullName!: string;
    public agentId!:string;
    public agentPhoneNumber?:string;
    public agentMobilePhoneNumber?:string;
    public agentEmail!:string;

    constructor(){}
}